export default {
  "name": "NCTextArea",
  "column": 1,
  "canAppend": false,
  "type": 1,
  "path": "LowCodeComponents.NCTextArea",
  "label": "大文本",
  "schema": {
    "type": "object",
    "properties": {
      "moduleId": {
        "title": "区域编码",
        "description": "组件标识",
        "type": "string"
      },
      "className": {
        "title": "className",
        "description": "样式",
        "type": "string"
      },
      "showMax": {
        "title": "显示最多字数限制",
        "description": "显示最多字数限制",
        "type": "boolean",
        "default": false
      },
      "fieldid": {
        "title": "自动化Id",
        "description": "自动化Id",
        "type": "string"
      },
      "maxlength": {
        "title": "最大长度",
        "description": "最大长度",
        "type": "number"
      },
      "isCheckChinese": {
        "title": "检查中文",
        "description": "检查中文",
        "type": "boolean",
        "default": false
      },
      "isFormularEditor": {
        "title": "公式编辑器",
        "description": "公式编辑器",
        "type": "boolean"
      },
      "canResize": {
        "title": "调整尺寸",
        "description": "调整尺寸",
        "type": "boolean",
        "default": true
      }
    },
    "required": [
      "moduleId"
    ]
  },
  "uiSchema": {},
  "slots": []
}